import { fetchWorksConcil, fetchWorksConcils } from '../queries/worksConcils.queries';

import { useQuery } from '@tanstack/react-query';

export const useWorksConcils = () => {
    return useQuery({
        queryKey: ['works-concils'],
        queryFn: fetchWorksConcils,
    });
};

export const useWorksConcil = (id: number) => {
    return useQuery({
        queryKey: ['works-concils', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchWorksConcil(id);
        },
    });
};
